import api from '../../../lib/api'

export const getFilters = params =>
    function get(dispatch) {
        api.getFilters(params, (error, response) => {
            if (error) {
                return dispatch(getFiltersError(error));
            }
            const results = {};

            response.data.data.map(res => results[res.id] = res);
            return dispatch(getFiltersSuccess(results));
        });
    };
export const getFiltersSuccess = data => ({
    type: 'GET_FILTERS_SUCCESS',
    data,
});

export const getFiltersError = msg => ({
    type: 'GET_FILTERS_ERROR',
    msg,
});
